import React from 'react';
import css from './card.module.scss';
import clsx from 'clsx';

const Header = ({ children }: React.PropsWithChildren) => {
  return <div className={css.header}>{children}</div>;
};

const Content = ({
  className,
  children,
}: React.PropsWithChildren<{ className?: string }>) => {
  return <div className={clsx(css.content, className)}>{children}</div>;
};

const Footer = ({ children }: React.PropsWithChildren) => {
  return <div className={css.footer}>{children}</div>;
};

const Card = ({
  className,
  children,
  rounded = false,
  bordered = false,
  shadow = false,
  background,
  padding = 'default',
}: React.PropsWithChildren<{
  className?: string;
  rounded?: boolean;
  bordered?: boolean;
  shadow?: boolean;
  background?: 'default' | 'gray';
  padding?: 'default' | 'small';
}>) => {
  return (
    <div
      className={clsx(
        className,
        css.root,
        shadow && css.shadow,
        rounded && css.rounded,
        bordered && css.bordered,
        background && css[`background-${background}`],
        padding && css[`padding-${padding}`],
      )}
    >
      {children}
    </div>
  );
};

export default Object.assign(Card, {
  Header,
  Content,
  Footer,
});
